module.exports = __webpack_public_path__ + "static/media/logo-footer.6ae95286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-footer.svg
// module id = 1990
// module chunks = 0